import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 20 20"
        ref={ref}
        {...props}
    >
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M7.55 6.59c0-.867.694-1.59 1.575-1.59h1.75c.88 0 1.575.723 1.575 1.59v1.779l-.001.062c-.002 1.524-.072 3.12-.6 4.348-.277.642-.69 1.213-1.303 1.617-.613.404-1.37.604-2.27.604a.7.7 0 1 1 0-1.4c.69 0 1.163-.152 1.5-.373.336-.222.592-.55.787-1.002.26-.607.387-1.38.444-2.272a1.594 1.594 0 0 1-.132.006h-1.75c-.88 0-1.575-.723-1.575-1.59v-1.78Z"
            clipRule="evenodd"
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
